import { Link } from 'react-router-dom';
import { Icon, IconName } from './Icon';
import { Challenge } from '../types';
import { paths } from '../paths';

interface Action {
  label: string;
  to?: string;
  icon?: IconName;
  disabled?: boolean;
}

/** Main action for the player's status. The server decides the status. */
function getAction(challenge: Challenge, short = false): Action {
  switch (challenge.attendance?.status) {
    case 'READY':
      return {
        label: short ? 'Gerar QR Code' : 'Gerar QR Code de entrada',
        to: paths.checkIn(challenge.id),
        icon: 'qr',
      };
    case 'CHECKED_IN':
      return {
        label: short ? 'Ver permanência' : 'Ver minha permanência',
        to: paths.inProgress(challenge.id),
        icon: 'clock',
      };
    case 'COMPLETED':
      return {
        label: 'Ver resultado',
        to: paths.result(challenge.id),
        icon: 'check',
      };
    case 'MISSED':
      return { label: 'Desafio encerrado', disabled: true };
    case 'NOT_OPEN':
    default:
      return { label: 'Ainda não disponível', disabled: true };
  }
}

interface PrimaryActionProps {
  challenge: Challenge;
  short?: boolean;
  className?: string;
}

export function PrimaryAction({
  challenge,
  short = false,
  className = '',
}: PrimaryActionProps) {
  const action = getAction(challenge, short);

  if (action.disabled || !action.to) {
    return (
      <button
        type="button"
        className={`pv-btn pv-btn--primary ${className}`}
        disabled
      >
        {action.label}
      </button>
    );
  }

  return (
    <Link to={action.to} className={`pv-btn pv-btn--primary ${className}`}>
      {action.icon && <Icon name={action.icon} size={18} />}
      {action.label}
    </Link>
  );
}
